import { ImageScaleView, ImageScaleViewOpts } from '@play-co/timestep-core/ui';
import { DOWNSCALE_FACTOR } from 'src/conf/scale';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';

export class LeaderboardsScore extends ImageScaleView {
  public readonly icon: ImageScaleView;
  public readonly label: LangBitmapFontTextView;

  constructor(opts: ImageScaleViewOpts) {
    super({
      width: 140,
      height: 48,
      ...opts,
      image:
        'assets/ui/weeklyLeaderboard/popups/popupLeaderboards/panel_list_inset.png',
      scaleMethod: '9slice',
      sourceSlices: {
        horizontal: { left: 30, right: 30 },
        vertical: { top: 30, bottom: 30 },
      },
      imgScale: DOWNSCALE_FACTOR,
    });

    this.icon = new ImageScaleView({
      superview: this,
      image:
        'assets/ui/weeklyLeaderboard/popups/popupLeaderboards/leaderboards_medal_weekly.png',
      width: 75,
      height: 75,
      centerOnOrigin: true,
      x: -5,
      y: this.style.height * 0.5,
      scaleMethod: 'contain',
    });

    this.label = new LangBitmapFontTextView({
      superview: this,
      align: 'center',
      verticalAlign: 'center',
      size: 28,
      font: 'Title',
      width: this.style.width,
      height: this.style.height - 3,
      color: '#FFFFFF',
      localeText: () => `999`,
    });
  }
}
